import React from 'react';
import './Footer.scss'

export interface UHCSidebarFooterProps {
    children: React.ReactNode;
}

const UHCSidebarFooter: React.FC<UHCSidebarFooterProps> = (props:UHCSidebarFooterProps) =>{
    return (
        <div data-testid='sidebar-footer' className="sidebar-footer">
            {props.children}
        </div>
    )
}

export default UHCSidebarFooter;